import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Constants } from "@hub/common/Constants";
import { eGridType } from "@hub/generated/enums";
import { GridDto, GridOptionDto } from "@hub/generated/models";
import { GridController } from "@hub/generated/services";
import { FilterService, NotificationService } from "@hub/services/index";
import { BaseComponent } from "@hub/common/BaseComponent";
import { ConfirmationService } from "primeng/api";
import { GridMessages } from "@hub/generated/_messages";

@Component({
  selector: "app-grid-option",
  templateUrl: "./gridOption.component.html"
})
export class GridOptionComponent extends BaseComponent implements OnInit {
  constructor(
    protected gridController: GridController,
    private filterService: FilterService,
    private notificationService: NotificationService,
    private confirmationService: ConfirmationService
  ) {
    super();
  }

  @Input() GridDto: any;
  @Output() onOpenGrid: EventEmitter<GridOptionDto> = new EventEmitter<GridOptionDto>();
  @Output() onEditGrid: EventEmitter<string> = new EventEmitter<string>();
  @Output() onRemoveGrid: EventEmitter<boolean> = new EventEmitter<boolean>();
  defaultGridId: string;
  gridId: string;
  ngOnInit() {
    if(this.GridDto) {
      this.defaultGridId = this.GridDto.DefaultGridId;
      this.gridId = this.GridDto.Id;
    }
   }

  SelectedClick(setting: GridOptionDto) {
    this.filterService.Clear();
    this.gridId = setting.Id;
    this.onOpenGrid.emit(setting);
  }

  EditClick(gridOption: GridOptionDto, event: MouseEvent) {
    event.stopPropagation()
    this.onEditGrid.emit(gridOption.Id);
  }

  RemoveClick(gridOption: GridOptionDto, event: MouseEvent) {
    event.stopPropagation()
    this.confirmationService.confirm({
      key: 'common',
      message: GridMessages.GridDeleteConfirmation,
      accept: () => {
        this.gridController.DeleteGrid(gridOption.Id).subscribe(data => {
          this.notificationService.success(GridMessages.GridDeleteSuccessItemMessage);
          if(gridOption.Id !== this.gridId) {
            this.GridDto.SelectOptions = this.GridDto.SelectOptions.filter(c => c.Id !== gridOption.Id);
            return;
          }
          if (!this.IsAreaDefault(gridOption.Id)) {
            let option = this.GridDto.SelectOptions.find(f => this.IsAreaDefault(f.Id));
            if (!option) {
              option = this.GridDto.SelectOptions.filter(f => f.GridType == eGridType.System)[0];
            }
            this.gridId = option.Id;
            this.onOpenGrid.emit(option);
          } else {
            let option = this.GridDto.SelectOptions.filter(f => f.GridType == eGridType.System)[0];
            this.gridId = option.Id;
            this.onOpenGrid.emit(option);
          }
        },
          err => {
            this.addError(err);
            this.notificationService.error(GridMessages.BaseErrorMessage);
          });
      },
      reject: () => {
        
      }
    });

    
  }

  SetDefault(id: string, event: MouseEvent) {
    event.stopPropagation()
    this.gridController
      .SetGridAsDefault(id, this.GridDto.GridArea)
      .subscribe(data => {
        this.defaultGridId = data;
      });
  }

  AddNewGrid() {
    this.onEditGrid.emit(Constants.GUID_EMPTY);
  }

  public optionsType(gridType: eGridType): GridOptionDto[] {
    if(this.GridDto) {
    if (
      this.GridDto.SelectOptions !== undefined &&
      this.GridDto.SelectOptions.length > 0
    ) {
      return this.GridDto.SelectOptions.filter(f => f.GridType === gridType);
    } else {
      return null;
    }
  }
  }

  public IsAreaDefault(id) {
    if (this.GridDto) {
      return this.defaultGridId === id;
    } else return false;
  }

  IsSelected(id){
    if (this.GridDto) {
      return this.gridId === id;
    } else return false;
  }
}
